module.exports = __webpack_public_path__ + "static/media/authorization_login.b67cd4fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/developerApi/developerSdk/Authentication/authorization_login.png
// module id = 1218
// module chunks = 0